module.exports = __webpack_public_path__ + "img/1.7f346d34.webp";